import { render, staticRenderFns } from "./OfferCampaignsModal.vue?vue&type=template&id=71b2f986&scoped=true"
import script from "./OfferCampaignsModal.vue?vue&type=script&lang=js"
export * from "./OfferCampaignsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2f986",
  null
  
)

export default component.exports